<script setup lang="ts">
import type { StrapiBlockCode, StrapiBlockInlineText } from '@nimbus/types'

const props = defineProps<StrapiBlockCode>()
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-html child is safe -->
    <div v-for="(child, index) in props.children" :key="index" v-html="(child as StrapiBlockInlineText).text" />
</template>

<style lang="scss" scoped>
:deep(tbody tr) {
    background: white;
}

:deep(thead) {
    background: white;
}

:deep(tbody tr:nth-child(2n + 1)) {
    background: $gray-lighter;
}

:deep(td, th) {
    vertical-align: top;
    padding: 5px;
}
</style>
